/*
 * Copyright © 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import SummaryDetailsItem from "@/src/components/Form/Common/SummaryDetailsItem/SummaryDetailsItem";
import SummaryDetailsProps from "@/src/types/SummaryDetailsProps";

const SummaryDetailsVehicle = ({ caseData: caseData }: SummaryDetailsProps) => {
  return (
    <>
      <SummaryDetailsItem fieldPath={"buyerOrSeller"} caseData={caseData} />
      <SummaryDetailsItem fieldPath={"isNewVehicle"} caseData={caseData} />
      <SummaryDetailsItem fieldPath={"vehicleMake"} caseData={caseData} />
      <SummaryDetailsItem fieldPath={"model"} caseData={caseData} />
      <SummaryDetailsItem fieldPath={"vehicleId"} caseData={caseData} />
      {caseData.objectiveClient === "withdrawal" && (
        <>
          <SummaryDetailsItem fieldPath={"mileageAtPurchase"} caseData={caseData} />
          <SummaryDetailsItem fieldPath={"currentMileage"} caseData={caseData} />
        </>
      )}

      <SummaryDetailsItem fieldPath={"purchasePrice"} caseData={caseData} />
      <SummaryDetailsItem fieldPath={"buyerPaidStatus"} caseData={caseData} />
      <SummaryDetailsItem fieldPath={"isThirdPartyFinanced"} caseData={caseData} />
      <SummaryDetailsItem fieldPath={"locationOfGood"} caseData={caseData} />
      <SummaryDetailsItem fieldPath={"hasDefects"} caseData={caseData} />

      {caseData.hasDefects === "yes" && (
        <>
          <SummaryDetailsItem fieldPath={"isAccidentCar"} caseData={caseData} />
          <SummaryDetailsItem fieldPath={"defectsRecognitionDate"} caseData={caseData} fieldType={"date"} />
          <SummaryDetailsItem fieldPath={"defectsDescriptionClient"} caseData={caseData} />
          <SummaryDetailsItem fieldPath={"numberRepairAttempts"} caseData={caseData} />
          <SummaryDetailsItem fieldPath={"numberReplacementAttempts"} caseData={caseData} />
        </>
      )}
    </>
  );
};

export default SummaryDetailsVehicle;
